/// <amd-module name="Widgets/Burndown/BurndownLegacyContracts" />

import { SemanticVersion, WidgetSize } from "Dashboards/WidgetContracts/WidgetProps";

export interface CustomSettings {
    /**
     * the settings data serialized as a string.
     */
    data: string;
    /**
     * (Optional) version for the settings represented as a semantic version object.
     * If none is available, the version defaults to {major:1, minor:0, patch:0} or "1.0.0"
     */
    version?: SemanticVersion;
}

export enum BurnDirection {
    Down,
    Up
}
export interface BurndownViewComponentProps extends ViewComponentProps {
    burnDirection: BurnDirection;
}

// ViewComponent contract
export interface ViewComponentProps {
    change: WidgetConfigChange;
    suppressAnimations: boolean;
    /*** Contract for signalling to consumer of render completion. Consumer must instantiate initial deferred object, in order to receive subsequent notification. */
    deferredRenderCompletion: any;
}

// ModernWidgetContract format, as defined on legacy Stack.

/** Describes what changed from the last known state.
 *  Important for reload scenario, to allow bypassing of costly querying and main body rendering.
 */
export enum ChangeFlags {
    none = 0,

    name = 1,
    sizeInPixels = 2,
    customSettings = 4,

    all = name | sizeInPixels | customSettings
}

/** Describes what framework operation originated a change event.  */
export enum WidgetFrameworkOperationId {
    preload,
    load,
    reload,
    lightbox,
    listen_lightboxResized,
    listen_lightboxOptions
}

/** Describes what a widget implementer needs to know to render. */
export interface NormalizedWidgetConfig {
    name: string;
    isLightBox: boolean;
    sizeInPixels: WidgetSize;
    customSettings: CustomSettings;

    /** Optional Legacy property, for non-lightbox scenario. Expresses widget size from Dashboard centric POV of rows and columns. */
    sizeInGrid?: WidgetSize;
}

export interface WidgetCreationOptions {
    typeId: string;
    getId: () => Promise<string>;
}

export interface WidgetConfigChange {
    /*** Identifies the Framework operation which triggered this change.  */
    operationId: WidgetFrameworkOperationId;

    /*** The new configuration state of the widget */
    config: NormalizedWidgetConfig;

    /*** The changes detected between new config and old config. */
    detectedChanges: ChangeFlags;

    /** Creation-time parameters of the Widget. */
    widgetCreationOptions: WidgetCreationOptions;
}
